import { createAsyncSelector, createSelector } from '@flux';
import { IAppState } from '@store';

const selectAsyncLeads = createAsyncSelector<Array<Lead>, IAppState>({
	get: state => state.leads.main.leads,
	selector: createSelector(
		state => state.leads.main.leads.item,
		item => item,
	),
});

const selectAsyncNewLeadSmsText = createAsyncSelector<string, IAppState>({
	get: state => state.leads.main.newLeadSmsText,
	selector: createSelector(
		state => state.leads.main.newLeadSmsText.item,
		item => item,
	),
});

function selectDateRange(state: IAppState) {
	return state.leads.main.dateRange;
}

export const mainLeadsSelectorsPack = {
	selectAsyncLeads,
	selectAsyncNewLeadSmsText,
	selectDateRange,
};
